const LOG_LEVELS = {
  DEBUG: 'debug',
  INFO: 'info',
  WARN: 'warn',
  ERROR: 'error'
}

const LOG_COLORS = {
  debug: '#6B7280',
  info: '#3B82F6',
  warn: '#F59E0B',
  error: '#EF4444'
}

const isDevelopment = process.env.NODE_ENV === 'development'

function getTimestamp() {
  const now = new Date()
  return now.toTimeString().split(' ')[0]
}

function formatMessage(level, message, context) {
  const timestamp = getTimestamp()
  const prefix = `[${timestamp}] [${level.toUpperCase()}]`

  if (context && Object.keys(context).length > 0) {
    return [prefix, message, context]
  }
  return [prefix, message]
}

function debug(message, context = {}) {
  if (!isDevelopment) return

  const args = formatMessage(LOG_LEVELS.DEBUG, message, context)
  console.log(`%c${args[0]}`, `color: ${LOG_COLORS.debug}`, ...args.slice(1))
}

function info(message, context = {}) {
  if (!isDevelopment) return

  const args = formatMessage(LOG_LEVELS.INFO, message, context)
  console.log(`%c${args[0]}`, `color: ${LOG_COLORS.info}`, ...args.slice(1))
}

function warn(message, context = {}) {
  if (!isDevelopment) return

  const args = formatMessage(LOG_LEVELS.WARN, message, context)
  console.warn(`%c${args[0]}`, `color: ${LOG_COLORS.warn}`, ...args.slice(1))
}

function error(message, context = {}) {
  if (!isDevelopment) return

  const args = formatMessage(LOG_LEVELS.ERROR, message, context)
  console.error(`%c${args[0]}`, `color: ${LOG_COLORS.error}`, ...args.slice(1))
}

const logger = {
  debug,
  info,
  warn,
  error,
  levels: LOG_LEVELS
}

export default logger

export { debug, info, warn, error, LOG_LEVELS }
